export const SCROLL_TO_TOP = 'scroll-to-top';

export default function scrollToTop() {
  window.scrollTo(0, 0);

  return {
    type: SCROLL_TO_TOP,
  };
}
